import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("th", null, "Mon", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("th", null, "Tue", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("th", null, "Wed", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", null, "Thu", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", null, "Fri", -1)
const _hoisted_6 = ["onMouseenter", "onMousedown"]

import { CalendarBrushes, useLeaveStore } from '@/stores/leave'
import { translate } from '@/helpers/translate'
import TextContent from '@/components/TextContent.vue'
import { computed, onMounted, onUnmounted, ref } from 'vue'
import CalendarDay from '@/components/CalendarDay.vue'

interface Column {
    date: Date
    visible: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Calendar',
  setup(__props) {

const leaveStore = useLeaveStore()
const { t } = translate()

const months = computed<Column[][][]>(() => {
    if (!leaveStore.personal.dueDate || !leaveStore.yearMonths) {
        return []
    }

    const months: Column[][][] = []

    leaveStore.yearMonths.forEach(yearMonth => {
        const firstDayOfMonth = new Date(yearMonth.year, yearMonth.month, 1)
        const prevMonday = new Date(firstDayOfMonth.getTime())
        prevMonday.setDate(prevMonday.getDate() - (prevMonday.getDay() + 6) % 7)

        let i = 0
        const weeks = []

        weekLoop:
            for (let iWeek = 0; iWeek < 6; iWeek ++) {
                const days = []

                for (let iDay = 0; iDay < 7; iDay ++) {
                    const date = new Date(prevMonday.getTime())
                    date.setDate(date.getDate() + i)
                    i ++

                    days.push({
                        date: date,
                        visible: date.getMonth() == firstDayOfMonth.getMonth(),
                    })
                }

                weeks.push(days)

                const lastDay = days[days.length - 1]
                const nextDay = new Date(lastDay.date.getTime())
                nextDay.setDate(lastDay.date.getDate() + 1)

                if (nextDay.getMonth() !== firstDayOfMonth.getMonth()) {
                    break weekLoop
                }
            }

        months.push(weeks)
    })

    return months
})

const isMouseDown = ref<boolean>(false)

function onMouseDown() {
    isMouseDown.value = true
}

function onMouseUp() {
    isMouseDown.value = false
}

onMounted(() => {
    window.addEventListener('mousedown', onMouseDown)
    window.addEventListener('mouseup', onMouseUp)
})

onUnmounted(() => {
    window.removeEventListener('mousedown', onMouseDown)
    window.removeEventListener('mouseup', onMouseUp)
})

function changeDay(date: Date) {
    if (leaveStore.activeBrush === CalendarBrushes.eraser) {
        leaveStore.setDay(date, false, true)
        leaveStore.setDay(date, false, false)
    } else if (leaveStore.activeBrush === CalendarBrushes.mom) {
        leaveStore.setDay(date, true, true)
    } else if (leaveStore.activeBrush === CalendarBrushes.partner) {
        leaveStore.setDay(date, true, false)
    }
}

function onClick(date: Date, visible: boolean) {
    if (!visible) return
    changeDay(date)
}

function onMouseEnter(date: Date, visible: boolean) {
    if (!visible) return
    if (isMouseDown.value) {
        changeDay(date)
    }
}

return (_ctx: any,_cache: any) => {
  return (_unref(leaveStore).personal.dueDate)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.$style.container)
      }, [
        _createVNode(TextContent, null, {
          default: _withCtx(() => [
            _createElementVNode("h2", null, _toDisplayString(_unref(t)('calendarTitle')), 1)
          ]),
          _: 1
        }),
        _createElementVNode("p", null, [
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.$style.brushIcon)
          }, "🖌", 2),
          _createTextVNode(" Select a brush to draw on the calendar ")
        ]),
        _createElementVNode("ul", {
          class: _normalizeClass(_ctx.$style.brushes)
        }, [
          _createElementVNode("li", {
            onClick: _cache[0] || (_cache[0] = () => _unref(leaveStore).setActiveBrush(_unref(CalendarBrushes).mom)),
            class: _normalizeClass({
            [_ctx.$style.brush]: true,
            [_ctx.$style.brushMom]: true,
            [_ctx.$style.brushActive]: _unref(leaveStore).activeBrush === _unref(CalendarBrushes).mom
        })
          }, "Mom is home", 2),
          _createElementVNode("li", {
            onClick: _cache[1] || (_cache[1] = () => _unref(leaveStore).setActiveBrush(_unref(CalendarBrushes).partner)),
            class: _normalizeClass({
            [_ctx.$style.brush]: true,
            [_ctx.$style.brushPartner]: true,
            [_ctx.$style.brushActive]: _unref(leaveStore).activeBrush === _unref(CalendarBrushes).partner
        })
          }, "Partner is home", 2),
          _createElementVNode("li", {
            onClick: _cache[2] || (_cache[2] = () => _unref(leaveStore).setActiveBrush(_unref(CalendarBrushes).eraser)),
            class: _normalizeClass({
            [_ctx.$style.brush]: true,
            [_ctx.$style.brushEraser]: true,
            [_ctx.$style.brushActive]: _unref(leaveStore).activeBrush === _unref(CalendarBrushes).eraser
        })
          }, "Eraser", 2)
        ], 2),
        _createElementVNode("table", {
          class: _normalizeClass({
        [_ctx.$style.table]: true,
        [_ctx.$style.tableWithMomBrush]: _unref(leaveStore).activeBrush === _unref(CalendarBrushes).mom,
        [_ctx.$style.tableWithPartnerBrush]: _unref(leaveStore).activeBrush === _unref(CalendarBrushes).partner,
        [_ctx.$style.tableWithEraserBrush]: _unref(leaveStore).activeBrush === _unref(CalendarBrushes).eraser,
    })
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(months), (month) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    colspan: "6",
                    class: _normalizeClass(_ctx.$style.monthHeader)
                  }, _toDisplayString(month[2][0].date.toLocaleString('default', { month: 'long' })), 3)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_1,
                  _hoisted_2,
                  _hoisted_3,
                  _hoisted_4,
                  _hoisted_5,
                  _createElementVNode("th", {
                    class: _normalizeClass(_ctx.$style.weekend)
                  }, "Sat", 2),
                  _createElementVNode("th", {
                    class: _normalizeClass(_ctx.$style.weekend)
                  }, "Sun", 2)
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(month, (week) => {
                return (_openBlock(), _createElementBlock("tr", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(week, (day) => {
                    return (_openBlock(), _createElementBlock("td", {
                      onMouseenter: () => onMouseEnter(day.date, day.visible),
                      onMousedown: () => onClick(day.date, day.visible),
                      class: _normalizeClass({[_ctx.$style.dayColumn]: true})
                    }, [
                      _createVNode(CalendarDay, {
                        date: day.date,
                        visible: day.visible
                      }, null, 8, ["date", "visible"])
                    ], 42, _hoisted_6))
                  }), 256))
                ]))
              }), 256))
            ], 64))
          }), 256))
        ], 2)
      ], 2))
    : _createCommentVNode("", true)
}
}

})